import baseApi from '@/modules/services/base';
import { NavigationsTag } from '@/modules/services/tags';
import { NavigationDataType } from '@/modules/types/navigation';
import config from '@/lib/config/index';
import { appData } from '@/lib/data';

const navigationApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getNavigations: build.query<NavigationDataType, void>({
      query: () => config.getNavigationURL,
      transformResponse: (navigation: NavigationDataType) => {
        const mappedNavigation: NavigationDataType = {
          ...navigation,
          menu: {
            ...navigation.menu,
            modules: [
              ...navigation.menu.modules.map((module) =>
                module.key === appData.menu.appCourseBuilderKey
                  ? {
                      ...module,
                      isSelected: true,
                    }
                  : module,
              ),
            ],
          },
        };

        return mappedNavigation;
      },
      providesTags: [NavigationsTag],
    }),
  }),
  overrideExisting: false,
});

export const { useGetNavigationsQuery } = navigationApi;

export default navigationApi;
